(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/get-payment-message/get-payment-done-message.js') >= 0) return;  svs.modules.push('/components/sport/get-payment-message/get-payment-done-message.js'); 'use strict';

var Currency = svs.utils.format.Currency;
var getGrasrotenMessageForDialogOrToaster = svs.sport.sport_common.getGrasrotenMessageForDialogOrToaster;

var getCost = function getCost(amount) {
  return "<span class=\"nowrap\">".concat(Currency(amount, false), " kr</span>");
};


function getPaymentDoneMessage(_ref, callback) {
  var amount = _ref.amount,
      productName = _ref.productName,
      compDesc = _ref.compDesc,
      competitionSignedUp = _ref.competitionSignedUp,
      tipsetBombenAmount = _ref.tipsetBombenAmount,
      _ref$numberOfGames = _ref.numberOfGames,
      numberOfGames = _ref$numberOfGames === void 0 ? 1 : _ref$numberOfGames,
      extraMessage = _ref.extraMessage,
      marketplaceUrl = _ref.marketplaceUrl,
      isRetailer = _ref.isRetailer,
      transferTo = _ref.transferTo,
      okAction = _ref.okAction;

  if (!amount || !productName) {
    throw new Error('Missing required properties `amount` or `productName`');
  }

  var returnObject = {
    paymentDoneDialogConfig: {
      branding: svs.components.dialog.branding.SPORT,
      icon: 'games',
      actions: [{
        title: 'OK'
      }]
    },
    transferDialogConfig: undefined
  };
  var message = '';
  var your = numberOfGames > 1 ? 'Dina' : 'Ditt';
  var payed = numberOfGames > 1 ? 'betalade' : 'betalat';
  var theGame = numberOfGames > 1 ? 'Spelen' : 'Spelet';

  if (okAction) {
    returnObject.paymentDoneDialogConfig.actions[0].callback = okAction;
  }

  if (competitionSignedUp) {
    message = "Du \xE4r anm\xE4ld till ".concat(compDesc, ".<br />");
  }

  if (compDesc) {
    returnObject.paymentDoneDialogConfig.title = "".concat(your, " ").concat(compDesc, "-spel \xE4r ").concat(payed);
    message += "".concat(theGame, " kostade ").concat(getCost(amount), ".");
  } else if (tipsetBombenAmount) {
    returnObject.paymentDoneDialogConfig.title = "".concat(your, " spel \xE4r ").concat(payed);
    message += "".concat(productName, " kostade ").concat(getCost(amount), " och Bomben kostade ").concat(getCost(tipsetBombenAmount), ".");
  } else {
    returnObject.paymentDoneDialogConfig.title = "".concat(your, " spel p\xE5 ").concat(productName, " \xE4r ").concat(payed);
    message += "".concat(theGame, " kostade ").concat(getCost(amount), ".");
  }

  function showAfterPaymentMessage(transferAbortAction, grasroten) {
    if (message) {
      returnObject.paymentDoneDialogConfig.message = [{
        type: svs.components.dialog.message.TEXT,
        text: message.trim()
      }];
    }

    if (extraMessage) {
      if (!returnObject.paymentDoneDialogConfig.message) {
        returnObject.paymentDoneDialogConfig.message = [];
      }

      extraMessage.forEach(function (mess) {
        returnObject.paymentDoneDialogConfig.message.push({
          type: svs.components.dialog.message.TEXT,
          text: mess
        });
      });
    }

    if (transferTo && transferTo.gameName) {
      returnObject.transferDialogConfig = {
        branding: svs.components.dialog.branding.SPORT,
        icon: 'nav-my-games',
        title: "Vill du \xF6verf\xF6ra dina rader till ".concat(transferTo.gameName, "?"),
        actions: [{
          title: 'Avbryt',
          callback: transferAbortAction
        }, {
          title: 'Överför',
          callback: function callback() {
            transferTo.transferAction();
          }
        }]
      };
    } else {
      if (!(grasroten && grasroten.hasSponsorship)) {
        if (okAction) {
          returnObject.paymentDoneDialogConfig.actions[0].callback = function () {
            svs.components.dialog.api.close();
            okAction();
            new svs.sport.GrassrootsToaster().show();
          };
        } else {
          returnObject.paymentDoneDialogConfig.actions[0].callback = function () {
            svs.components.dialog.api.close();
            new svs.sport.GrassrootsToaster().show();
          };
        }
      } else if (okAction) {
        returnObject.paymentDoneDialogConfig.actions[0].callback = function () {
          svs.components.dialog.api.close();
          okAction();
        };
      } else {
        returnObject.paymentDoneDialogConfig.actions[0].callback = function () {
          svs.components.dialog.api.close();
        };
      }
    }

    returnObject.paymentDoneDialogConfig.actions.unshift({
      title: 'Mina spel',
      callback: function callback() {
        location.href = svs.utils.urlMapping.get('myBetsHome');
      }
    });
    callback(returnObject);
  }

  if (isRetailer) {
    message += '<br />Du kan nu stänga fliken.';
    returnObject.paymentDoneDialogConfig.message = [{
      type: svs.components.dialog.message.TEXT,
      text: message.trim()
    }];
    callback(returnObject);
  } else {
    var game = tipsetBombenAmount || numberOfGames > 1 ? 'dem' : 'det';
    message += " Du hittar ".concat(game, " ").concat(compDesc ? 'i Tips-SM-fliken och' : '', " under Mina spel");

    if (marketplaceUrl) {
      message += " och p\xE5 <a class=\"alert-text-link\" href=\"".concat(marketplaceUrl, "\">lagsidan</a>");
    }

    message += '. ';
    getGrasrotenMessageForDialogOrToaster().then(function (grasroten) {
      var transferAbortAction;

      if (grasroten.hasSponsorship) {
        message += grasroten.thankYouMessage;

        transferAbortAction = function transferAbortAction() {
          transferTo.abortAction(false);
        };
      } else {
        transferAbortAction = function transferAbortAction() {
          transferTo.abortAction(false);
          new svs.sport.GrassrootsToaster().show();
        };
      }

      showAfterPaymentMessage(transferAbortAction, grasroten);
    }).catch(function () {
      showAfterPaymentMessage(function () {}, undefined);
    });
  }
}

setGlobal('svs.components.sport.getPaymentDoneMessage', getPaymentDoneMessage);
 })(window);